import React from 'react';
import CourseComponent from 'Components/Card/Components/CourseComponent';
import ScheduleCourseSubComponent from 'Components/Card/Components/ScheduleCourseSubComponent';
import styles from 'assets/css/CourseComponent.module.css';
import withSMARTGoalOnUpdateCardComponent from 'Components/Card/hoc/withSMARTGoalOnUpdateCardComponent';

function LMSCourseAndScheduledCourseCard(props) {

    const { Course: course, ScheduledCourse: scheduleCourse } = props.data;
    return (
        <div className={styles["aceU--live-class"]}>
            <CourseComponent course={course} />
            <ScheduleCourseSubComponent course={scheduleCourse} cardToolsSubheader = {props.cardToolsSubheader} />
        </div>
    )
}

export default withSMARTGoalOnUpdateCardComponent(LMSCourseAndScheduledCourseCard);
